import { store } from "../store";

const allowed = ["/payment"];
const COURSE_ID = localStorage.getItem("courseNum");

export default (to, from, next) => {
  const user = store.getters.user;
  const chpaters = store.getters.course;
  const chpaterNum = store.getters.course.length;
  const nextChapter = store.getters.nextChapter;
  const nextLesson = store.getters.nextLesson;
  const query = to.query;
  
  switch (to.name) {
    case "dictionary":
    case "settings":
    case "leader-board":
    case "home":
      next({path: "/chapter/", query: query});
      break;
    case "chapter":
      if (!user) {
        next({path: "/welcome/", query: query})
        break;
      }
      const addedToHomeScreen = localStorage.getItem('addedToHomeScreen')
      if (addedToHomeScreen == null) {
        next({path: "/install/", query: query});
        break;
      }
      else {
        next({query: query});
      }
      break;
    case "index":
      next({path: "/chapter/", query: query});
      break;
    case "chapter-check":
      // console.log(chpaterNum);
      // console.log(
      //   user.chapter.filter(res => res.chapter.course == 3 && res.is_done)
      // );
      if (nextChapter.id && chpaters && Object.keys(chpaters).length) {
        const chap = chpaters.findIndex(res => res.id == nextChapter.id) + 1;
        if (chap) {
          next({path: `/chapter/${chap}`, query: query});
          break;
        }
      }
      if (nextLesson && chpaters && Object.keys(chpaters).length) {
        const chap =
          chpaters.findIndex(res => res.id == nextLesson.chapter) + 1;
        console.log(chap);
        if (chap) {
          next({path: `/chapter/${chap}`, query: query});
          break;
        }
      }
      if (
        user &&
        user.chapter &&
        user.chapter.length &&
        user.chapter.filter(
          res => res.chapter.course == COURSE_ID && res.is_done
        ).length +
          1 <=
          chpaterNum
      ) {
        next({
          path: `/chapter/${user.chapter.filter(
            res => res.chapter.course == COURSE_ID && res.is_done
          ).length + 1}`,
          query: query
        });
        break;
      }

      next({path: "/chapter/1", query: query});
      break;
    case "audio":
      if (!user) {
        next({path: "/welcome/", query: query})
      } else if (
        (user.premium && user.premium.active) ||
        allowed.includes(to.fullPath)
      ) {
        next({query: query});
      } else {
        next({path: "/payment/", query: query})
      }
      break;

    case "profile":
    // case "saved-words":
    //   if (user) {
    //     next();
    //   } else {
    //     next("/");
    //   }
    //   break;
    // case "login":
    //   next("/");
    //   break;
    default:
      next({query: query});
  }
};



// WEBPACK FOOTER //
// ./src/router/auth-guard.js